import React from 'react'
import { SterikIcon } from '../utils/icons'
import growth from '../assets/growth.png'

const GrowthCard = ({ item }) => {
    return (
        <div className='relative border-[6px] border-[#ECE8CE] bg-bgprimary rounded-[20px] p-4 md:w-[300px] ' >
            <div className=" absolute top-0 left-0">
                <SterikIcon />
            </div>
            <div className="img">
                <img src={item?.image} className='w-full h-60 object-cover rounded-xl' alt="" />
            </div>
            <div className="content  md:w-[260px]">
                <h3 className='text-dark font-roboto-mono font-bold italic text-base tracking-[6%] mt-4' >
                    {item?.title}
                </h3>
                <p className='text-dark font-quicksand font-medium text-sm' >
                    {item?.description}
                </p>
            </div>
        </div>
    )
}

export default GrowthCard
